import { Dropdown } from 'primereact/dropdown';
import React from 'react'
import { useJenkins } from '../../Hooks/Features/HelpDesk/useJenkins';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';


const JenkisRequest = ({ projectOpts, setShowRequestPopup, callApi, editData, setEditData }) => {
    const { jenkinsRequestUpsert, handleChange, jenkinsRequestData, options, handleEvent ,loader} = useJenkins({ projectOpts, setShowRequestPopup, callApi, editData })
    return (
        <div>
            <div className="w30 mt-2">
                <div className="mt-2">Project Name*</div>
                <Dropdown className="input-dd" options={projectOpts} optionLabel="project_name" value={jenkinsRequestData.project_id} onChange={handleChange} placeholder="Project" filter filterInputAutoFocus name="project_id" />
            </div>
            {
                options?.envOption?.length > 0 && <div className="my-1">
                    <div className=" mt-2">Select Environment*</div>
                    <Dropdown className="input-dd" options={options?.envOption} optionLabel="environment_name" value={jenkinsRequestData.environment_id} onChange={handleChange} placeholder="Select Environment" filter filterInputAutoFocus name="environment_id" />
                </div>
            }
            {
                options?.jenkinsTypeOption?.length > 0 && <div className="my-1">
                    <div className="mt-2">Select Jenkins Type*</div>
                    <Dropdown className="input-dd" options={options?.jenkinsTypeOption} optionLabel="jenkins_type_name" value={jenkinsRequestData.jenkins_type_ids} onChange={handleChange} placeholder="Select jenkins" filter filterInputAutoFocus name="jenkins_type_ids" />
                </div>
            }
            {
                options?.jenkinsSubTypeOption?.length > 0 && <div className="my-1">
                    <div className="mt-2">Select Jenkins Sub Type</div>
                    <Dropdown className="input-dd" options={options?.jenkinsSubTypeOption} optionLabel="sub_type_name" value={jenkinsRequestData.jenkins_sub_type_ids} onChange={handleChange} placeholder="Select Sub Type" filter filterInputAutoFocus name="jenkins_sub_type_ids" />
                </div>
            }
            {
                options?.jenkinsJobTypeOption?.length > 0 && <div className="my-1">
                    <div className="mt-2">Select Job</div>
                    <MultiSelect
                        options={options?.jenkinsJobTypeOption}
                        filter
                        filterInputAutoFocus
                        placeholder="Select Job"
                        value={jenkinsRequestData.jenkins_job_ids}
                        optionLabel="job_name"
                        name='jenkins_job_ids'
                        onChange={(e) => handleChange(e)}
                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'jenkins_job_ids', jenkinsRequestData.jenkins_job_ids, () => { }, handleEvent)}
                    />
                </div>
            }
            {options?.approverOption?.length > 0 &&
                <div>
                    <div className="mt-2">Approve By</div>
                    <div className="d-flex gap-1 mt-2" >
                        {options?.approverOption.map((item) => (<div>
                            {item.user_code !== null &&
                                <div key={item?.user_code} className="d-flex align-items-center">
                                    <input type="radio" id={item?.user_code} name="approver_user_code" value={item?.user_code} onChange={handleChange} checked={parseInt(jenkinsRequestData?.approver_user_code) === item?.user_code} />
                                    <label htmlFor={item?.user_code} name="approve_by">{item.user_display_name}</label>
                                </div>
                            }
                        </div>
                        ))}
                    </div>
                </div>
            }
            <div>
                <div className="mt-2">Reason</div>
                <textarea rows={2} placeholder="Write reason for Jenkins" className="w100 form-control border" name="reason" value={jenkinsRequestData.reason} onChange={handleChange} />
            </div>
            <div className="d-flex justify-content-between">
                {jenkinsRequestData.reason?.trim()?.split(" ")?.length > 5 ? <span></span> :
                    <span>{jenkinsRequestData.reason?.split(" ")?.[0]?.length === 0 ? 0 : jenkinsRequestData.reason?.trim()?.split(" ")?.length}/5 words</span>
                }
                <div className="d-flex justify-content-end align-items-center mt-3">
                    <button className="button btn-default" onClick={() => { setShowRequestPopup(false); setEditData({}) }}>Cancel</button>
                    {
                        loader ? <button className="button btn-primary" style={{ width: "60px", height: "30px" }}>
                            <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className="button btn-primary" onClick={jenkinsRequestUpsert}>Submit</button>
                    }

                </div>
            </div>
        </div>
    )
}

export default JenkisRequest